import React from 'react';
import Icon from '@/v2/components/atoms/Icon';

import './Burger.scss';

const Burger = (props) => (
    <Icon iconName="Burger" {...props}>
        <svg viewBox="0 0 15 9.5" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <path strokeWidth={0} d="M0 7.5h8.75v2H0zM0 0h15v2H0z" />
        </svg>
    </Icon>
);

export default Burger;
